(function () {
  function initHeaderV3(root) {
    if (!root || root.dataset.hv3Init) return;
    root.dataset.hv3Init = '1';
    var items = root.querySelectorAll('.nav__item');
    var openScrollY = 0;

    function closeAll() {
      items.forEach(function (i) {
        i.classList.remove('open');
        var b = i.querySelector('button.nav__link');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      root.classList.remove('hv3-mega-open');
    }

    // Plafonne la hauteur du menu ouvert à la place restante sous l'en-tête : un menu plus haut
    // que l'écran obligeait à faire défiler la page, ce qui le referme (écouteur scroll ci-dessous).
    function fitMega(item) {
      var mega = item.querySelector('.mega');
      if (!mega) return;
      var top = mega.getBoundingClientRect().top;
      mega.style.setProperty('--hv3-mega-max', Math.max(240, window.innerHeight - top) + 'px');
    }

    items.forEach(function (item) {
      var btn = item.querySelector('button.nav__link');
      if (!btn) return; // Inspirations = lien simple, pas de dropdown
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var wasOpen = item.classList.contains('open');
        closeAll();
        if (!wasOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
          root.classList.add('hv3-mega-open');
          openScrollY = window.scrollY;
          fitMega(item);
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.hv3 .nav__item')) closeAll();
    });
    // Le header sticky du thème change d'état au scroll (header-scrolled/pinned,
    // translateY animé) : un mega resté ouvert serait emporté dans le saut.
    // On le ferme dès que le défilement dépasse quelques pixels.
    window.addEventListener('scroll', function () {
      if (!root.classList.contains('hv3-mega-open')) return;
      if (Math.abs(window.scrollY - openScrollY) > 8) closeAll();
    }, { passive: true });
    window.addEventListener('resize', function () {
      var open = root.querySelector('.nav__item.open');
      if (open) fitMega(open);
    });
  }

  document.querySelectorAll('.hv3').forEach(initHeaderV3);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.hv3');
    if (root) initHeaderV3(root);
  });
})();
